import { Helmet } from 'react-helmet-async';
import { useRecoilValue } from 'recoil';
import { pageState } from '../../storage/app';
import { usePages } from '../../hooks/usePages';

type Props = {
  title?: string;
};

export function HeadTitle({ title }: Readonly<Props>) {
  const page = useRecoilValue(pageState);
  const { getPageTitle } = usePages();
  if (!title) title = getPageTitle(page);

  return (
    <Helmet>
      <title>GNP Km Seguros {title ? `- ${title}` : ''}</title>
    </Helmet>
  );
}
